import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder, userManagement } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['dashboard'],
  endpoints: (builder) => ({
    getAdminDashboardData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.dashboardController.getAdminDashboardData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getServiceProviderData: builder.mutation({
        query(body) {
          return {
            url: spotFinder.dashboardController.getServiceProviderData,
            method: 'POST',
            headers: { Authorization: `Bearer ${body.token}` },
            body: body.payload,
          };
        },
      }),
     
getVendorDashboardData: builder.mutation({
        query(body) {
          return {
            url: spotFinder.dashboardController.getVendorDashboardData,
            method: 'POST',
            headers: { Authorization: `Bearer ${body.token}` },
            body: body.payload,
          };
        },
      }),
  }),
});

export const { useGetAdminDashboardDataMutation,useGetServiceProviderDataMutation,useGetVendorDashboardDataMutation } = dashboardApi;
